import React from "react";
import Cookies from "js-cookie";
import { getSignedIdStatus } from "../../../../common/utils/utilsFunc";

const RemoveCookieIfNotLoggedIn = () => {

    React.useEffect(() => {
        if (!getSignedIdStatus()) {
            Cookies.remove("cognito-access-token");
        }
    }, []);

    return (
        <div></div>
    );
};

export default RemoveCookieIfNotLoggedIn;
